export interface TierConfig {
  title: string;
  color: string;
  nodes: string[];
}

export const TIERS: TierConfig[] = [
  {
    title: "Client & Delivery",
    color: "#4f83ff",
    nodes: ["Client Browser", "Cloud CDN & HTTPS LB"],
  },
  {
    title: "Application",
    color: "#9b5de5",
    nodes: [
      "NGINX Ingress",
      "React Frontend (Vite + Mantine)",
      "GraphQL API (Fastify/Apollo)",
    ],
  },
  {
    title: "Data",
    color: "#ff914d",
    nodes: ["Prisma ORM", "PostgreSQL (Cloud SQL)", "Redis Cache"],
  },
  {
    title: "Platform & DevOps",
    color: "#4ad7d1",
    nodes: [
      "Docker",
      "Artifact Registry",
      "GKE Staging",
      "GKE Production",
      "GitHub Actions CI",
    ],
  },
];

export const DOC_LINKS_STACK: Record<string, string> = {
  "React Frontend (Vite + Mantine)": "/docs/frontend",
  "GraphQL API (Fastify/Apollo)": "/docs/backend/graphql",
  "Prisma ORM": "/docs/backend/prisma",
  "PostgreSQL (Cloud SQL)": "/docs/data/postgres",
  "Redis Cache": "/docs/data/redis",
  "NGINX Ingress": "/docs/infra/ingress",
  Docker: "/docs/devops/docker",
  "Artifact Registry": "/docs/devops/artifact-registry",
  "GKE Staging": "/docs/devops/environments#staging",
  "GKE Production": "/docs/devops/environments#production",
  "GitHub Actions CI": "/docs/devops/ci",
};
